export default __webpack_public_path__ + "static/media/polygons-no-1.06e72e83.ogg";